import { JSX } from "react";
import styled from "styled-components";

interface ModalProps {
  onClose?: () => void;
  children?: JSX.Element;
}

export function Modal({ onClose, children }: ModalProps) {
  if (children === undefined) {
    return <></>;
  }
  return <ModalContainer onClick={onClose}>{children}</ModalContainer>;
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;
